import React from 'react'

export const Labels = () => {
  return (
    <div className='example-container'>
      <label className='label'>Label for Input</label>
    </div>
  )
}
